module.exports = __webpack_public_path__ + "static/01-80ea9ef2eae92acbfe68aa23bc51cc5d.jpg";